import * as ActionTypes from 'app/common/constants/action-types';
import { getSearchLoc, setELLFromSearchLoc } from 'app/common/helpers/cookie';
import { getQueryStringValue } from 'app/common/helpers/url';
import { loadInAppMessages } from 'app/common/actions/inAppMessages';
import timeAgoTranslations from 'app/common/helpers/timeAgoTranslations';
import { loadAuth } from 'app/common/actions/auth';
import {
  getRecentSearches,
  getRecentLocations,
} from 'app/common/helpers/search';
import { fetchCartSize } from 'app/common/helpers/cartSize';

/** Init state by server side data and local data */
export function init(initState) {
  const { location } = initState;
  const searchLoc = getSearchLoc() || {};
  const search = {
    query: getQueryStringValue('query'), // get query param from url
  };
  const {
    lat,
    lng,
    closestDivision: division,
    currentLocation,
    fullAddress: address,
  } = searchLoc;

  setELLFromSearchLoc(); // set ELL from searchLoc cookie

  return {
    type: ActionTypes.INITIALIZE,
    payload: Object.assign(initState, {
      searchLoc,
      search,
      location: {
        ...location,
        lat: lat || location.lat,
        lng: lng || location.lng,
        division: division || location.division,
        address: address || location.address,
        currentLocation: currentLocation || location.currentLocation,
      },
    }),
  };
}

export function fetchData() {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      const state = getState();

      dispatch(loadAuth()); // load user auth info
      // load stored recent searches
      const recentSearches = getRecentSearches();
      dispatch({
        type: ActionTypes.UPDATE_RECENT_SEARCHES,
        recentSearches,
      });

      // load stored recent locations
      const recentLocations = getRecentLocations();
      dispatch({
        type: ActionTypes.UPDATE_RECENT_LOCATIONS,
        recentLocations,
      });

      timeAgoTranslations.importTranslations(state.app.lang);

      // load iam
      Promise.all([dispatch(loadInAppMessages()), dispatch(loadCartSize())])
        .then(() => resolve())
        .catch(() => {});
    });
  };
}

/**
 * Get cart size from API
 */
export function loadCartSize() {
  return (dispatch, getState) => {
    const { flags } = getState();
    if (!flags.showCart) {
      return Promise.resolve({});
    }

    return fetchCartSize()
      .then(cartSize => {
        dispatch({
          type: ActionTypes.UPDATE_CART_SIZE,
          cartSize,
        });
      })
      .catch(() => {});
  };
}
